/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkWorkflowtasktype } from '../models/work-workflowtasktype';

@Injectable({ providedIn: 'root' })
export class WorkWorkflowtasktypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `workflowtasktypesV2ControllerFindAll()` */
  static readonly WorkflowtasktypesV2ControllerFindAllPath = '/v2/workflowtasktypes';

  /**
   * Required permissions: workflows:read, workflows:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workflowtasktypesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  workflowtasktypesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkWorkflowtasktype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWorkflowtasktypesV2Service.WorkflowtasktypesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkWorkflowtasktype>>;
      })
    );
  }

  /**
   * Required permissions: workflows:read, workflows:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workflowtasktypesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  workflowtasktypesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkWorkflowtasktype>> {
    return this.workflowtasktypesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkWorkflowtasktype>>): Array<WorkWorkflowtasktype> => r.body)
    );
  }

}
